// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"69":"7bf876d1","70":"3f67a973","354":"f435781b","827":"f435781b","995":"46e71713"}[chunkId] + ".chunk.css";
};